import React from 'react';
import { string } from 'prop-types';

const TickIcon = ({ color = 'font1-color', fontSize = '20px', className = '' }) => (
  <span
    style={{
      color: `var(--${color})`,
      fontSize: fontSize
    }}
    className={`icon-ic_done ${className}`}
  />
);

TickIcon.propTypes = {
  color: string,
  fontSize: string,
  className: string
};

export default TickIcon;
